module.exports = __webpack_public_path__ + "img/AM.98cafd90.jpg";